module.exports = ".dashboard-container .stats-banner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  padding: 8px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.scss
// module id = ./src/app/dashboard/dashboard.component.scss
// module chunks = main